import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";
import helperSpinner from "../../../../helpers/spinner";
import helperNumbers from "../../../../helpers/numbers";
import helpersTime from "../../../../helpers/time";
import httpService from "../../../../services/httpServices/httpServices";
import Pagination from "../../../partials/content/Pagination";
import StatusAskCheckout from "./StatusAskCheckout";

export default function All() {
  const [allAskCheckout, setAllAskCheckout] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [amountSearchFilter, setAmountSearchFilter] = useState(0);

  useEffect(() => {
    getAllAskCheckout();
  }, [currentPage, amountSearchFilter]);

  const getAllAskCheckout = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let allAskCheckout = await sendRequestGetAllAskCheckout(searchFilterQuery);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!allAskCheckout) {
      return;
    }
    setAllAskCheckout(allAskCheckout.ask_checkout);
    setCountPage(allAskCheckout.count_page);
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (amountSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&price=${amountSearchFilter}`;
    }

    return searchFilterQuery;
  };

  const sendRequestGetAllAskCheckout = async (searchFilterQuery) => {
    const headersRequest = getHeaderRequest();
    let allAskCheckout;
    try {
      allAskCheckout = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/marketer/ask-checkout?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allAskCheckout.data.data;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateDoseNotHaveAnyAskCheckout = () => {
    return (
      <div className="d-flex flex-column flex-md-row">
        <div className="text-center text-md-right">
          <img src="/assets/img/do-not-have-position.svg" />
        </div>
        <div className="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
          <p> شما در حال حاضر شما هیچ درخواست تسویه حساب ای ندارید :(</p>
          <p> برای شروع کار یک درخواست تسویه حساب جدید بسازید.</p>
          <p>
            <Link to="/marketer/add-ask-checkout" className="btn btn-success">
              <span className="pl-2">
                <i className="fa fa-plus"> </i>
              </span>
              <span>درخواست تسویه حساب جدید</span>
            </Link>
          </p>
        </div>
      </div>
    );
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const generateAskCheckout = () => {
    return (
      <>
        <div className="pb-2">
          <Link to="/marketer/add-ask-checkout" className="btn btn-success">
            <span className="pl-2">
              <i className="fa fa-plus"> </i>
            </span>
            <span>درخواست تسویه حساب جدید</span>
          </Link>
        </div>

        <div class="container-fluid pb-2">
          <div class="row border border-1 rounded py-2">
            <div class="col-12 col-md-4">
              <div>
                <label>جستجو در مبلغ</label>
              </div>
              <div>
                <input
                  className="form-control"
                  type="number"
                  onKeyUp={(e) => setAmountSearchFilter(e.target.value)}
                  onWheel={(event) => event.currentTarget.blur()}
                  placeholder="مبلغ  را در اینجا وارد کنید"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="table-responsive pt-2">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره درخواست</td>
                <td>مبلغ</td>
                <td>نام مالک حساب</td>
                <td>نام بانک</td>
                <td>وضعیت</td>
                <td>تاریخ ارسال درخواست</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {allAskCheckout.map((item, index) => {
                let classBadgeStatePage;
                switch (item.status) {
                  case StatusAskCheckout.getStatusAskCheckoutString()[
                    StatusAskCheckout.statusAskCheckout.PENDING
                  ]:
                    classBadgeStatePage = "badge-warning";
                    break;
                  case StatusAskCheckout.getStatusAskCheckoutString()[
                    StatusAskCheckout.statusAskCheckout.PAID
                  ]:
                    classBadgeStatePage = "badge-info";
                    break;
                  case StatusAskCheckout.getStatusAskCheckoutString()[
                    StatusAskCheckout.statusAskCheckout.REJECT
                  ]:
                    classBadgeStatePage = "badge-danger";
                    break;
                }
                return (
                  <tr>
                    <td>{helperNumbers.toPersianNum(index + 1)}</td>
                    <td>{helperNumbers.toPersianNum(item.id)}</td>
                    <td className="letter-spacing-finance-number">
                      {helperNumbers.toPersianNum(
                        helperNumbers.toFormatFinanceNumber(item.price)
                      )}
                    </td>
                    <td>{item.owner_account_name}</td>
                    <td>{item.bank_name}</td>
                    <td>
                      <span className={`badge ${classBadgeStatePage}`}>
                        {item.status}
                      </span>{" "}
                    </td>
                    <td>
                      {helperNumbers.toPersianNum(
                        item.created_at.split(" ")[1] +
                          " " +
                          helpersTime.convertGregorianToJalali(
                            item.created_at.split(" ")[0]
                          )
                      )}
                    </td>
                    <td>
                      <Link
                        to={`/marketer/view-ask-checkout/${item.id}`}
                        className="btn btn-info"
                      >
                        <i className="fa fa-info"></i>
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  return (
    <>
      <Sidebar activeItem="all-checkout" />

      <div className="content-wrapper">
        <TitleBar title="درخواست های تسویه حساب" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              {allAskCheckout.length == 0 && amountSearchFilter == 0
                ? generateDoseNotHaveAnyAskCheckout()
                : generateAskCheckout()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
